import { useIsMountedRef as e } from "./useIsMountedRef.js";
import { c as t } from "react/compiler-runtime";
import { useState as n } from "react";
//#region src/hooks/useOpenCloseState.ts
var r = (r) => {
	let i = t(8), [a, o] = n(r !== void 0 && r), s = e(), c;
	i[0] === s ? c = i[1] : (c = () => {
		s.current && o(!0);
	}, i[0] = s, i[1] = c);
	let l = c, u;
	i[2] === s ? u = i[3] : (u = () => {
		s.current && o(!1);
	}, i[2] = s, i[3] = u);
	let d = u, f;
	return i[4] !== d || i[5] !== a || i[6] !== l ? (f = [
		a,
		l,
		d
	], i[4] = d, i[5] = a, i[6] = l, i[7] = f) : f = i[7], f;
};
//#endregion
export { r as useOpenCloseState };
